<div class="row">
    <div class="col-sm-12 ">
        <div class="text-center">
            <h3 class="sub-title ">Task Template</h3>
            <a [routerLink]="['/task/template/show',taskTemplate.id]" >  {{taskTemplate.name}}</a>
        </div>


<div class="table-responsive" *ngIf="taskTemplate.questions.length>0">
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
    <th>Id</th>
    <th>Question</th>


    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let question of taskTemplate.questions;">
        <td>

            {{question.server_question_id}}

        </td>
        <td> {{question.questionText}}</td>

    </tr>

    </tbody>

</table>
</div>
<div *ngIf="taskTemplate.questions.length==0"> No questions Found</div>
<app-spinner *ngIf="loading"></app-spinner>
</div>

